module.exports = __webpack_public_path__ + "static/media/imdb.adf0f6e3.png";